import PartnersPage from 'src/components/pages/PartnersPage';
import PlaceholderPage from 'src/components/pages/PlaceholderPage';
import RedirectPage from 'src/components/pages/RedirectPage';
import MobileAppPage from 'src/components/pages/loyalty/MobileAppPage';
import ReferralPage from 'src/components/pages/loyalty/ReferralPage';
import RewardsPage from 'src/components/pages/loyalty/RewardsPage';
import SharingPage from 'src/components/pages/loyalty/SharingPage';

import SolarCashPage from './pages/loyalty/SolarCash';

import AboutUsPage from 'components/pages/AboutUsPage';
import NewsPage from 'components/pages/NewsPage';
import ReportsPage from 'components/pages/ReportsPage';

const map = {
  placeholderPage: PlaceholderPage,
  redirectPage: RedirectPage,
  rewardsPage: RewardsPage,
  referralPage: ReferralPage,
  mobileAppPage: MobileAppPage,
  sharingPage: SharingPage,
  solarCash: SolarCashPage,
  aboutUsPage: AboutUsPage,
  partnersPage: PartnersPage,
  newsPage: NewsPage,
  reportsPage: ReportsPage,
};

export default map;
